import React from 'react'
import { change, Field, reduxForm } from 'redux-form'
import { renderers, validations, FormButtons } from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import { TicketService } from '../../services'
import { FormsConstants } from '../../state/forms'
import { useDispatch } from 'react-redux'

let RegistrationForm = (props) => {
  const {
    handleSubmit,
    pristine,
    reset,
    submitting,
    checkEmail,
    emailAvailabilityMessage,
    isEmailAvailable,
    gsxAuthTokenURL,
  } = props
  const dispatch = useDispatch()
  const getPinCodeInfo = (e) => {
    new TicketService().get_pin_code_info(e.target.value).then((res) => {
      dispatch(change('RegistrationForm', 'city', res['District']))
    })
  }

  return (
    <form autocomplete="off" onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="first_name"
            type="text"
            component={renderers.renderField}
            label="First Name"
            validate={[validations.required]}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="last_name"
            type="text"
            component={renderers.renderField}
            label="Last Name"
            validate={[validations.required]}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="email"
            type="email"
            component={renderers.renderField}
            label="Email"
            onBlur={checkEmail}
            validate={[validations.required, validations.email]}
          />
          <h6
            style={{ marginTop: '-10px' }}
            className={isEmailAvailable ? 'text-success' : 'text-danger'}
          >
            {emailAvailabilityMessage}
          </h6>
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="contact_number"
            type="text"
            component={renderers.renderField}
            label="Contact Number"
            validate={[validations.required, validations.contactNumber]}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="pin_code"
            type="text"
            onBlur={getPinCodeInfo}
            component={renderers.renderField}
            label="PIN Code"
            validate={[validations.required]}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="city"
            type="text"
            component={renderers.renderField}
            label="City"
            validate={[validations.required]}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="gsx_user_name"
            type="text"
            component={renderers.renderField}
            label="GSX User Name"
            validate={[validations.required]}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="gsx_technician_id"
            type="text"
            component={renderers.renderField}
            label="GSX Technician ID"
            validate={[validations.required]}
          />
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            name="gsx_ship_to"
            type="text"
            component={renderers.renderField}
            label="GSX Ship To"
            validate={[validations.required, validations.minLength(10)]}
          />
        </ReactBootstrap.Col>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <Field
            style={{ marginBottom: '0px' }}
            name="gsx_auth_token"
            type="text"
            component={renderers.renderField}
            label="GSX Auth Token"
            validate={[validations.required]}
          />

          <p style={{ padding: '0px' }} className="text-end">
            <a
              rel="noopener noreferrer"
              style={{ marginTop: '-10px' }}
              className=" text-dark btn-sm"
              href={gsxAuthTokenURL}
              target="_blank"
            >
              Click Here to Retrieve GSX Auth Token
            </a>
          </p>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <p>
        <FormButtons
          submitting={submitting}
          pristine={pristine}
          reset={reset}
        />
      </p>
    </form>
  )
}
RegistrationForm = reduxForm({
  form: 'RegistrationForm',
  asyncBlurFields: ['email'],
})(RegistrationForm)
export default RegistrationForm
